import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NavBar.css';
import { useAuth } from '../context/AuthContext';
import avatar from '../assets/avatar.jpg';

interface NavbarProps {
  logoSrc: string;
  appName: string;
  onLogout: () => void;
  isMobile?: boolean;
  onToggleMobileMenu?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ logoSrc, appName, onLogout, isMobile, onToggleMobileMenu }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleProfileClick = () => {
    navigate('/profile');
    setShowDropdown(false);
  };

  return (
    <div className="navbar">
      {/* Mobile hamburger menu - moved to left */}
      {isMobile && (
        <button className="hamburger-menu" onClick={onToggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}
      
      <div className="navbar-logo">
        <img src={logoSrc} alt="Logo" />
        <span>{appName}</span>
      </div>
      
      {/* Desktop avatar - hidden on mobile */}
      {!isMobile && (
        <div className="navbar-avatar" ref={dropdownRef}>
          {isLoading ? (
            <div className="navbar-avatar-skeleton" />
          ) : (
            <img
              src={user?.avatarSrc || avatar}
              alt="User Avatar"
              onClick={() => setShowDropdown(!showDropdown)}
            />
          )}
          <div className={`avatar-dropdown ${showDropdown ? 'show' : ''}`}>
            <div className="dropdown-item welcome">
              Hola, {user?.firstname || 'User'}
            </div>
            <div className="dropdown-item" onClick={handleProfileClick}>
              <i className="fas fa-user"></i>
              Perfil
            </div>
            <div className="dropdown-item" onClick={onLogout}>
              <i className="fas fa-sign-out-alt"></i>
              Cerrar sesión
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
